import React, { useState } from "react";
import AddButton from "components/ui/Button/AddButton/AddButton";
import AddBranchModal from "../../../modals/AddBranchModal/AddBranchModal";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { CAPSULE_CREATE_PERMISSION } from "components/dashboard/KnowledgeBase/permissions";
import {
    isPostFormBranchCollection,
    POST_FORM_WORKFLOW_UPDATE_PERMISSION,
} from "components/dashboard/KnowledgeBase/PostForms/permissions";
import { ISSUE_CONVERSATION_CREATE_PERMISSION } from "components/dashboard/TrainSAM/SAM/WorkflowSettings/permissions";
import { baseResources, baseResourceActions } from "routes/enum";
import "./BranchesTimeLineHeader.scss";

const { KB_SAM_BRANCH } = baseResources;
const { CREATE } = baseResourceActions;

const BranchesTimeLineHeader = ({
    source,
    referenceData,
    handleRefresh,
    collectionBranches,
    isAgentGuideView,
}) => {
    const [showModal, toggleModal] = useState(false);

    const branchCreatePermissions = isPostFormBranchCollection(source)
        ? POST_FORM_WORKFLOW_UPDATE_PERMISSION
        : [
              ...CAPSULE_CREATE_PERMISSION,
              `${CREATE}_${KB_SAM_BRANCH}`,
              ...ISSUE_CONVERSATION_CREATE_PERMISSION,
          ];

    return (
        <>
            <div className='branches__header'>
                <div className='row align-items-center'>
                    <div className='col-md-4'>
                        <h6 className='main__subheading main__subheading--md'>
                            Conversation Branches
                        </h6>
                    </div>
                    <div className='col-md-2 ms-auto'>
                        <ComponentAccessControl
                            baseResources={branchCreatePermissions}>
                            <AddButton
                                btnText={"Add a Branch"}
                                otherClassName='justify-content-end'
                                onClick={() => {
                                    toggleModal(true);
                                }}
                            />
                        </ComponentAccessControl>
                    </div>
                </div>
            </div>
            {showModal && (
                <AddBranchModal
                    show={showModal}
                    source={source}
                    closeModal={() => toggleModal(false)}
                    handleBranchAddSuccess={(branchId) => {
                        toggleModal(false);
                        handleRefresh(branchId);
                    }}
                    handleRefresh={handleRefresh}
                    isAgentGuideView={isAgentGuideView}
                    existingBranches={collectionBranches}
                    referenceData={referenceData}
                />
            )}
        </>
    );
};

export default BranchesTimeLineHeader;
